import { useAppSelector } from '@common/hooks/store';
import { selectUserCityId } from '@features/auth/slice/authSlice';
import CitySelectorForm from '@features/city-selector/CitySelectorForm';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function CitySelector() {
  const cityId = useAppSelector(selectUserCityId);

  if (cityId === 0) {
    return (
      <Dialog
        open={true}
        keepMounted={true}
        PaperProps={{
          sx: {
            boxShadow: 'none',
          },
          elevation: 2,
        }}
      >
        <DialogTitle>
          <FormattedMessage id="PLEASE_CONFIRM_CITY"/>
        </DialogTitle>
        <DialogContent>
          <CitySelectorForm/>
        </DialogContent>
      </Dialog>
    );
  }
  return null;
}
